/** @format */

import React, { forwardRef, useEffect, useImperativeHandle, useState, useMemo } from "react";
import { isString } from "../../utils/utils";
import { Dropdown } from "primereact/dropdown";

export default forwardRef((props, ref) => {
  const [filterText, setFilterText] = useState(null);
  const { filterChangedCallback, context } = props;
  const { userSatuses } = context;
  // expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => {
    return {
      doesFilterPass(params) {
        const { api, colDef, column, columnApi, context } = props;
        const { node } = params;
        const value = props.valueGetter({
          api,
          colDef,
          column,
          columnApi,
          context,
          data: node.data,
          getValue: (field) => node.data[field],
          node,
        });
        let __filterText = filterText !== "Pending Approval" ? filterText : "New";
        return isString(value) && isString(filterText) && value.toLowerCase() === __filterText.toLowerCase();
      },

      isFilterActive() {
        return filterText != null
      },
    };
  });

  const onChange = (event) => {
    setFilterText(event.target.value);
  };

  useEffect(() => {
    filterChangedCallback();
  }, [filterText, filterChangedCallback]);

  const options = useMemo(() => userSatuses.map(val => val === "New" ? "Pending Approval" : val), [userSatuses])
  return (
    <div style={{ padding: 4 }}>
      {/* <select onChange={onChange}>
        {options.map(option => <option key={option} value={option}>{option}</option>)}
      </select> */}
      <Dropdown
        value={filterText}
        onChange={onChange}
        options={options}
        placeholder='Select a Status'
        showClear
        className='w-full'
        pt={{
          input: "py-1",
        }}
      />
    </div>
  );
});
